// src/components/PeoplePlan/TheBench/components/WorkflowKanban/KanbanCard.js
import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { WORKFLOW_ICONS } from "../../utils/workflowConstants";

const KanbanCard = ({ employee, onEmployeeSelect }) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id: employee.user_id,
      data: { employee },
    });

  const style = {
    transform: transform
      ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
      : undefined,
    transition: isDragging ? "none" : "transform 0.2s ease-out",
  };

  const workflowIcon = employee.workflow_name && employee.workflow_name !== "N/A" 
    ? WORKFLOW_ICONS[employee.workflow_name] 
    : null;

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      className={`kanban-card ${isDragging ? "dragging" : ""} ${employee.isMoving ? "isMoving" : ""}`}
      style={style}
      onClick={() => onEmployeeSelect(employee)}
    >
      <p className="employee-name">{employee.employee_name}</p>
      
      <p>
        <span>
          <span className="label">MUM:</span>{" "}
          <span className="detail">{employee.mum_name}</span>
        </span>
        {workflowIcon && (
          <div className="tooltip-wrapper">
            <span className="workflow-icon-emoji" title={employee.workflow_name}>
              {workflowIcon}
            </span>
            <div className="tooltip">{employee.workflow_name}</div>
          </div>
        )}
      </p>

      <p>
        <span>
          <span className="label">Location:</span>{" "}
          <span className="detail">{employee.corp}</span>
        </span>
      </p>
    </div>
  );
};

export default KanbanCard;